export function IconLock() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill="currentColor" fillRule="evenodd" d="M5.5 0a2.75 2.75 0 0 0-2.75 2.75v1.768a1.75 1.75 0 0 0-1.5 1.732v4c0 .966.784 1.75 1.75 1.75h6a1.75 1.75 0 0 0 1.75-1.75v-4a1.75 1.75 0 0 0-1.5-1.732V2.75A2.75 2.75 0 0 0 6.5 0h-1zM9 6H3a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h6a.25.25 0 0 0 .25-.25v-4A.25.25 0 0 0 9 6zM7.75 4.5V2.75c0-.69-.56-1.25-1.25-1.25h-1c-.69 0-1.25.56-1.25 1.25V4.5h3.5z"/>
        </svg>
    );
}
